import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LifeBuoy, X, Mail, MessageSquare, Gift } from "lucide-react";

export function SupportWidget() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <button
        onClick={() => setOpen((v) => !v)}
        data-testid="support-fab"
        aria-label="Support"
        className="fixed z-[70] right-4 bottom-24 lg:right-6 lg:bottom-6 w-14 h-14 rounded-full btn-gold shadow-[0_8px_24px_rgba(242, 188, 46,0.35)] flex items-center justify-center hover:scale-105 transition-transform"
      >
        {open ? <X size={22} /> : <LifeBuoy size={22} />}
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-[68]" onClick={() => setOpen(false)} />
          <div className="fixed z-[69] right-4 bottom-40 lg:right-6 lg:bottom-24 w-[300px] max-w-[calc(100vw-2rem)] bg-[#141414] border border-white/10 rounded-2xl overflow-hidden shadow-2xl pg-fade-up" data-testid="support-panel">
            <div className="px-4 py-3 bg-gradient-to-r from-[#F2BC2E]/15 to-transparent border-b border-white/5">
              <div className="flex items-center gap-2">
                <Gift size={16} className="text-[#F2BC2E]" />
                <p className="font-display font-bold text-white text-sm">Support PROGÈRE — gratuit</p>
              </div>
              <p className="text-[11px] text-gray-400 mt-0.5">Inclus avec tous les forfaits · disponible en tout temps.</p>
            </div>
            <div className="p-3 space-y-2">
              <button onClick={() => { setOpen(false); navigate("/support"); }} data-testid="support-open-tickets"
                className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg bg-[#0f0f0f] border border-white/10 hover:border-[#F2BC2E]/40 transition-colors text-left">
                <MessageSquare size={16} className="text-[#F2BC2E] shrink-0" />
                <span className="text-sm text-gray-200">Ouvrir un billet de support</span>
              </button>
              <a href="mailto:support@progere.ca" data-testid="support-email"
                className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg bg-[#0f0f0f] border border-white/10 hover:border-[#F2BC2E]/40 transition-colors">
                <Mail size={16} className="text-[#F2BC2E] shrink-0" />
                <span className="text-sm text-gray-200">support@progere.ca</span>
              </a>
              <p className="text-[11px] text-gray-500 text-center pt-1">Support en ligne seulement pour l'instant.</p>
            </div>
          </div>
        </>
      )}
    </>
  );
}
